var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    className: "info",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information_1_",
    "data-name": "information (1)",
    fill: "currentColor",
    transform: "translate(4.806 4.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    className: "cls-1",
    d: "M7 0a7 7 0 1 0 7 7 7.008 7.008 0 0 0-7-7zm0 12.727A5.727 5.727 0 1 1 12.727 7 5.734 5.734 0 0 1 7 12.727z",
    transform: "translate(-4.806 -4.806)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    className: "cls-1",
    d: "M145.863 70a.861.861 0 1 0 .861.861.862.862 0 0 0-.861-.861z",
    transform: "translate(-143.669 -71.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    className: "cls-1",
    d: "M150.646 140a.646.646 0 0 0-.646.646v3.873a.646.646 0 0 0 1.291 0v-3.873a.646.646 0 0 0-.645-.646z",
    transform: "translate(-148.451 -138.916)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3a7f3836.svg";
export { ForwardRef as ReactComponent };